const ENDPOINT_CENTER_SERVICES = '/secure/centers/:centerId/services'
const ENDPOINT_SERVICE_DELETE = '/secure/services/:serviceId'
const ENDPOINT_SERVICE_PATCH = '/secure/service/:serviceId'
const ENDPOINT_SERVICE_GET = '/services/:serviceId'
const ENDPOINT_SERVICE_CREATE = '/secure/services'

export const state = () => ({})

export const mutations = {}

export const getters = {}

export const actions = {
  async fetchServices({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_CENTER_SERVICES.replace(':centerId', payload) + '?ascending=1'
        //         + '?query=&limit=10&ascending=1&page=1&byColumn=0'
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchService({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_SERVICE_GET.replace(':serviceId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async deleteService({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.delete(
        ENDPOINT_SERVICE_DELETE.replace(':serviceId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async updateService({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.patch(
        ENDPOINT_SERVICE_PATCH.replace(':serviceId', payload.serviceId),
        payload.model
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async createService({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.post(ENDPOINT_SERVICE_CREATE, payload)
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  }
}
